import { getActiveProductName } from './helpers';

export interface GTMEventData {
  eventName: string;
  eventType?: string;
  eventValue?: string;
  extraData?: Record<string, any>;
}

/** EventName will get prefixed with "myscp." */
export const PushToGoogleTagManager = ({
  eventName,
  eventType,
  eventValue,
  extraData
}: GTMEventData) => {
  if (!navigator.onLine || !(window as any).dataLayer) return;

  // "interaction" naming matches previous app nomenclature but maybe could be better ¯\_(ツ)_/¯
  const payload = {
    event: getActiveProductName() + '.' + eventName,
    InteractionType: eventType || eventName,
    InteractionValue: eventValue,
    CurrentLocation: window.location.href,
    ...extraData
  };

  (window as any).dataLayer.push(payload);
};
